/**
 * Cart drawer variant-linked recommendations — quick add.
 *
 * Listens for clicks on `.js-cart-rec-add` inside the cart drawer and
 * performs an AJAX add-to-cart, then refreshes the cart drawer in place.
 *
 * This version logs heavily to help diagnose issues.
 */
(function () {
  'use strict';

  var TAG = '[cart-variant-recs]';
  console.log(TAG, 'script loaded at', new Date().toISOString());

  if (window.__cartVariantRecsInit) {
    console.log(TAG, 'already initialised — aborting duplicate init');
    return;
  }
  window.__cartVariantRecsInit = true;

  var IN_FLIGHT = false;

  function getCartDrawer() {
    return document.getElementById('cart-drawer');
  }

  function refreshCartDrawer(data) {
    var drawer = getCartDrawer();
    if (!drawer) {
      console.warn(TAG, 'no #cart-drawer element found for refresh');
      return;
    }

    // Prefer the theme's public renderContents() if available (CartDrawer class).
    if (typeof drawer.renderContents === 'function' && data && data.sections) {
      console.log(TAG, 'refreshing via drawer.renderContents with sections:', Object.keys(data.sections));
      try {
        drawer.renderContents(data, true, null);
        return;
      } catch (e) {
        console.warn(TAG, 'renderContents threw, falling back:', e);
      }
    }

    // Fallback: dispatch the theme's refresh event.
    console.log(TAG, 'dispatching dispatch:cart-drawer:refresh as fallback');
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
  }

  function addToCart(variantId, buttonEl) {
    console.log(TAG, 'addToCart called with variantId:', variantId);

    if (IN_FLIGHT) {
      console.log(TAG, 'request already in-flight, ignoring click');
      return;
    }
    IN_FLIGHT = true;

    var cartDrawer = getCartDrawer();
    var sectionId = cartDrawer && cartDrawer.dataset ? cartDrawer.dataset.section : null;
    var sections = sectionId ? sectionId + ',cart-icon-bubble' : 'cart-icon-bubble';

    console.log(TAG, 'cart-drawer element:', cartDrawer, 'data-section:', sectionId);

    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', 1);
    formData.append('sections', sections);
    formData.append('sections_url', window.location.pathname);

    var addUrl = (window.theme && window.theme.routes && window.theme.routes.cartAdd)
      ? window.theme.routes.cartAdd
      : '/cart/add';
    var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart)
      ? window.theme.routes.cart
      : '/cart';

    console.log(TAG, 'POST', addUrl, 'variant', variantId);

    buttonEl.classList.add('is-loading');
    buttonEl.disabled = true;

    fetch(addUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (response) {
        console.log(TAG, 'response status:', response.status);
        return response.text().then(function (text) {
          var data;
          try { data = JSON.parse(text); } catch (_) { data = { raw: text }; }
          if (!response.ok) {
            var msg = (data && (data.description || data.message)) || ('HTTP ' + response.status);
            console.warn(TAG, 'add failed:', msg, data);
            throw new Error(msg);
          }
          console.log(TAG, 'add succeeded. variant_id:', data.variant_id, 'sections keys:', data.sections ? Object.keys(data.sections) : 'none');
          return data;
        });
      })
      .then(function (data) {
        refreshCartDrawer(data);

        return fetch(cartUrl + '.js', {
          headers: { Accept: 'application/json' }
        })
          .then(function (r) { return r.json(); })
          .then(function (newCart) {
            console.log(TAG, 'dispatching on:cart:add. item_count:', newCart.item_count);
            document.dispatchEvent(new CustomEvent('on:cart:add', {
              bubbles: true,
              detail: {
                cart: newCart,
                variantId: data.variant_id
              }
            }));
          })
          .catch(function (e) { console.warn(TAG, 'cart.js follow-up failed (non-fatal):', e); });
      })
      .catch(function (err) {
        console.error(TAG, 'add flow errored:', err);
        try {
          document.dispatchEvent(new CustomEvent('on:cart:error', {
            bubbles: true,
            detail: { error: err && err.message }
          }));
        } catch (_) {}
        buttonEl.classList.remove('is-loading');
        buttonEl.disabled = false;
      })
      .then(function () {
        IN_FLIGHT = false;
      });
  }

  // When items are added / removed / quantity-changed in the drawer, the
  // theme only refreshes the cart-items area — not the recommendations area.
  // That leaves stale rec markup visible even after the cart is emptied.
  // Hook into the theme's events and force a full drawer refresh so
  // cart-variant-recs re-renders against the new cart state (or vanishes
  // when cart is empty).
  function fullDrawerRefresh() {
    var drawer = getCartDrawer();
    if (!drawer) return;

    // Remove stale rec markup IMMEDIATELY so it's never visually stuck.
    var staleRecs = document.querySelector('.cart-variant-recs');
    if (staleRecs) staleRecs.remove();

    if (typeof drawer.refresh === 'function') {
      try {
        drawer.refresh(true); // true = skip partial cart-items refresh, do full section re-fetch
        return;
      } catch (e) {
        console.warn(TAG, 'drawer.refresh threw, falling back:', e);
      }
    }
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
  }

  document.addEventListener('on:line-item:change', function (event) {
    var cart = event && event.detail && event.detail.cart;
    var itemCount = cart ? cart.item_count : null;
    console.log(TAG, 'on:line-item:change — item_count:', itemCount);
    fullDrawerRefresh();
  });

  // Also handle cart:add events triggered from outside (other product forms).
  document.addEventListener('on:cart:add', function (event) {
    var cart = event && event.detail && event.detail.cart;
    console.log(TAG, 'on:cart:add — item_count:', cart && cart.item_count);
    // Don't refresh here — the originating handler already does it. But if cart
    // is empty for some reason (shouldn't happen), still clean up.
    if (cart && cart.item_count === 0) {
      var staleRecs = document.querySelector('.cart-variant-recs');
      if (staleRecs) staleRecs.remove();
    }
  });

  // Delegated click handler — works even after drawer innerHTML is replaced.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var btn = target.closest('.js-cart-rec-add');
    if (!btn) return;

    console.log(TAG, 'click captured on .js-cart-rec-add', btn);

    if (btn.disabled) {
      console.log(TAG, 'button is disabled — ignoring');
      return;
    }

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) {
      console.warn(TAG, 'button missing data-variant-id', btn);
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    addToCart(variantId, btn);
  }, true); // use capture so nothing swallows it first

  console.log(TAG, 'delegated click listener bound on document');
}());
